import { createSlice } from "@reduxjs/toolkit";
const initialAuthorizationState = { isAccessAllowed: false };

export const authorizationSlice = createSlice({
  name: "authorization",
  initialState: initialAuthorizationState,
  reducers: {
    adminUser(state) {
      state.isAccessAllowed = true;
    },
    normalUser(state) {
      state.isAccessAllowed = false;
    },
  },
});
